import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=13b937a4&"
import script from "./Inventory.vue?vue&type=script&lang=js&"
export * from "./Inventory.vue?vue&type=script&lang=js&"
import style0 from "./Inventory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports